import {useEffect, useState} from "react";
import { useSnackbar } from 'notistack';
import {useDeleteContactMutation} from "../../../services/authService";
import styles from "../showName/DeleteShowName.module.scss";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import messages from "../../../utils/messages";
import ConfirmDialog from "../../ConfirmDialog";


const DeleteContact = ({ contact, setContact, contactData, setContactData, onDelete }) => {
    const [deleteContact, { isSuccess, error, reset }] = useDeleteContactMutation();
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        deleteContact(contact.id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteContact}`, { variant: 'success' });
            onDelete();
            reset();
            setContact(null);
            setContactData({
                ...contactData,
                contacts: contactData?.contacts?.filter(c => !c.isDeleted),
            });
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <ConfirmDialog
                title="Delete contact"
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteContact}
            </ConfirmDialog>
        </>
    )
}

export default DeleteContact;
